import type { IGenerateAnimationData, IGetBackgroundAndSvg } from './login-types';

import { BG_CODES, LOGIN_COLORS, STAR_CODES } from 'constants/login-images';

import StarSvg from 'screens/forgot-password/star-svg';
import { getSvgString } from 'utils/svg-image';

export const getBackgroundAndSvg = (): IGetBackgroundAndSvg => {
  const bgKeys = Object.keys(LOGIN_COLORS);
  const randomColor = (bgKeys[Math.floor(Math.random() * bgKeys.length)] ||
    LOGIN_COLORS.GREEN) as keyof typeof LOGIN_COLORS;

  const background =
    BG_CODES[randomColor] || (BG_CODES[LOGIN_COLORS.GREEN as string] as string);
  const starBg = STAR_CODES[randomColor] || STAR_CODES[LOGIN_COLORS.GREEN as string];

  const svgString = getSvgString(StarSvg, starBg);

  return {
    bgCode: randomColor,
    background,
    svgString,
  };
};

const getRandomNum = (max: number) => Math.floor(Math.random() * max);

export const generateAnimationData = (): IGenerateAnimationData => {
  const arr = [0, 1, 2, 3, 4, 5];

  const animationDuration: { [key: number]: number } = {};
  const animationNumber: { [key: number]: number } = {};

  arr.forEach(val => {
    animationDuration[val] = getRandomNum(6);
    animationNumber[val] = getRandomNum(2);
  });

  return { animationDuration, animationNumber };
};
